const en = {
	risk: {
		riskTitle: 'Blacklist',
		group: 'Group',
		store: 'Website',
		omniStore: 'Store/Website',

		type: 'Type',
		status: 'Status',
		invalidText: 'When the cardholder submits a new transaction, the transaction under this rule will no longer be automatically intercepted。',
		enableText: 'The blacklist rule will take effect immediately',
		title_enable: 'ENABLE',
		title_invalid: 'DISABLE',
		success: 'The operation was successful',
		notUpload: "You haven't uploaded the file, you can' t submit it!",
		downloadFile: 'DOWNLOAD TEMPLATE',
		bulkUploadText: 'Please fill in the information and upload according to the format of bulk add template file',
		bulkTitle: 'Bulk Add',
		data: 'Data',
		country: 'Country',
		state: 'Province / State',
		city: 'City',
		adrress: 'Street',
		format: 'Both formats are available:',
		format1: '1.Complete card number, eg. “1234567890123456”',
		format2: '2.First 6 digits-****-last 4 digits',
		omniApplyTo: 'All stores and websites',
		omniApplyAll: 'When new stores and websites are added into current groups in the future, current rule will be automatically generated.',
		applyTo: 'All websites',
		applyAll: 'When new websites are added into current groups in the future, current rule will be automatically generated',
		cancel: 'Cancel',
		save: 'Save'

	},
	button: {
		add: 'Add new rule',
		bulkAdd: 'BULK ADD',
		enable: 'ENABLE',
		disable: 'DISABLE',
		introduction: 'Blacklist type introduction'

	},
	table: {
		type: 'Type',
		rule: 'Rule',
		store: 'Store name',
		omniStore: 'Store/Website',
		createTime: 'Created time',
		updateTime: 'Updated time',
		operator: 'Operator',
		status: 'Status',
		action: 'Action',
		edit: 'Edit'

	},
	introduction: {
		title: 'Blacklist type introduction',
		tip1: 'Once the information in the transaction exactly matches the blacklist rule, the transaction will be intercepted.',
		tip2: 'You can only see and manage the websites you assigned.',
		omniTip2: 'You can only see and manage the stores and websites you assigned.',
		q1: '1. Blacklist dimension interpretation',
		q2: '2. Where to find the above information?',
		q2Desc: "Find the menu bar, click: Transaction -> Transaction Log -> transaction pipeline number, jump to the 'Transaction Details' page",
		q3: '3. Where to find the Acc ID？',
		q3Desc: 'Find the menu bar ‘Website Management’ and find the website you want to configure the blacklist rules. Acc ID as shown below:',
		omniQ3Desc: 'Find the menu bar ‘Store/Website Management’ and find the website you want to configure the blacklist rules. Acc ID as shown below',

		card: 'Card No.',
		card_desc: 'Complete card number、First 6 digits-****-last 4 digits',
		card_example: '1234567890123456、123456****1234',
		phone: 'Phone',
		phone_desc: 'Shipping phone',
		phone_example: '8617700000000',
		email: 'Email',
		email_desc: 'Shipping email',
		email_example: 'XXX@hotmail.com',
		emailDomain: 'Domain name',
		emailDomain_desc: 'Shipping domain name',
		emailDomain_example: 'hotmail.com',
		address: 'Shipping Address',
		address_desc: 'Shipping address',
		address_example: '400,Fifth Avenue, New York City,State of New York,United States',
		type: 'Type',
		desc: 'Description',
		example: 'Example',
		comfirm: 'Comfirm'
	}
}

export default en
